import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

import { HttpService } from './http.service';
import { PackageMaster, PackageMasterPayload } from '../../../interfaces/masters/packagemaster';

@Injectable()
export class PackageMasterApi {

  constructor(private api: HttpService) { }

  list(url: string): Observable<any[]> {
    return this.api.get(url, {
      headers: {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json"
      }
    });
  }

  getById(url: string): Observable<PackageMaster> {
    return this.api.get(url, {
      headers: {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json"
      }
    });
  }

  add(url: string, data: PackageMasterPayload): Observable<any> {
    const header = new HttpHeaders();

    return this.api.post(url, data, header);
  }

  update(url: string, data: PackageMasterPayload): Observable<any> {
    return this.api.put(url, data, {
      headers: {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json"
      }
    });
  }

  delete(url: string): Observable<any> {
    return this.api.directDelete(url);
  }

}